import { Container, Text } from 'pixi.js-legacy';
import { ScalableTextManager, } from './scalableTextManager';
export class ScalingText extends Container {
    constructor(parent, options) {
        super();
        this.options = options;
        this.texts = [];
        this.currentIndex = 0;
        this.setParent(parent);
        this.populatePossibleScales();
        this.resizeCallback = this.options.onResize.bind(parent);
    }
    populatePossibleScales() {
        for (let i = 1; i < 16; ++i) {
            const text = new Text(this.options.text, {
                fontFamily: this.options.font,
                fontSize: i * this.options.size + 'px',
                fill: this.options.fill,
                wordWrap: this.options.wordWrap,
                wordWrapWidth: this.options.wordWrapWidth,
                align: this.options.align,
            });
            text.scale.x = 1 / (1 + i);
            text.scale.y = 1 / (1 + i);
            text.position.x = this.options.x;
            text.position.y = this.options.y;
            text.anchor.set(this.options.anchor.x, this.options.anchor.y);
            text.rotation = this.options.rotation;
            this.texts.push(text);
        }
    }
    getCurrentScale(scale = null) {
        if (scale == null) {
            this.currentIndex = Math.floor(ScalableTextManager.getInstance().container.scale.x);
            return this.texts[this.currentIndex];
        }
        else {
            this.currentIndex = Math.floor(scale);
            return this.texts[this.currentIndex];
        }
    }
}
